exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-95fa32c8]{margin-bottom:10px}.icon_form[data-v-95fa32c8]{margin-top:10px}.icon_form .input_wrapper>div[data-v-95fa32c8]:last-child{margin-bottom:0}.tools span[data-v-95fa32c8]{margin-left:10px;color:#666666}\n", ""]);

// exports
